module.exports = __webpack_public_path__ + "static/media/Digital-Price-Tag-Four-Horizontal.732c2f0d.jpg";